import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import styled from 'styled-components'
// Components
import {PrimaryButton, Layout } from '../components'
// Mui
import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Checkbox from '@material-ui/core/Checkbox'

const Delete = () => {

    const dispatch = useDispatch()

    const [check01, setCheck01] = useState(false)
    const [check02, setCheck02] = useState(false)
    const [check03, setCheck03] = useState(false)

    return (
        <Layout>
            <div className='spacer-100' />
            <h1 style={{textAlign: 'center'}}>退会手続き</h1>
            <div className='spacer-50' />

            <Wrapper>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <Checkbox color={'primary'}
                                edge="start" checked={check01}
                                tabIndex={-1} disableRipple
                                onChange={()=>setCheck01(!check01)}
                            />
                        </ListItemIcon>
                        <ListItemText id={1} primary={`XXXXXXXXXXXX XXXXXXXXXXXXXXXXXX XXXXXXXX`} />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <Checkbox color={'primary'}
                                edge="start" checked={check02}
                                tabIndex={-1} disableRipple
                                onChange={()=>setCheck02(!check02)}
                            />
                        </ListItemIcon>
                        <ListItemText id={2} primary={`XXXXXXXXXXXX XXXXXXXXXXXXXXXXXX XXXXXXXX`} />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <Checkbox color={'primary'}
                                edge="start" checked={check03}
                                tabIndex={-1} disableRipple
                                onChange={()=>setCheck03(!check03)}
                            />
                        </ListItemIcon>
                        <ListItemText id={3} primary={`XXXXXXXXXXXX XXXXXXXXXXXXXXXXXX XXXXXXXXXXXXXX`} />
                    </ListItem>
                </List>
            </Wrapper>

            <div className='spacer-50' />
            
            <div style={{textAlign: 'center'}}>
                <PrimaryButton 
                    label='退会する'
                    disabled={!(check01 && check02 && check03)}
                    operation={()=>{
                        window.confirm('一度削除したアカウントは元に戻せません。退会してよろしいですか？')
                    }} 
                />
                <div className='spacer-50' />
                <Button onClick={()=>dispatch(push('/mypage'))}>マイページに戻る</Button>
            </div>

            <div className='spacer-100' />
        </Layout>
    )
}

export default Delete

const Wrapper = styled.div`
    width: 480px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`